import { type ObjectValuesUnionType } from '../../../../utils/typing';

export const GRStateActionTypes = Object.freeze({
  UPDATE_STATE: 'GIFT_RACE:UPDATE_STATE',
  SKIP_CURRENT_TMP_NOTIFICATION: 'GIFT_RACE:SKIP_CURRENT_TMP_NOTIFICATION',
  SKIP_ALL_TMP_NOTIFICATIONS: 'GIFT_RACE:SKIP_ALL_TMP_NOTIFICATIONS',
  FILL_TEMPORARY_NOTIFICATIONS: 'GIFT_RACE:FILL_TEMPORARY_NOTIFICATIONS',
  SET_HOME_VISITED_INDEX: 'GIFT_RACE:SET_HOME_VISITED_INDEX',
  TRIGGER_NOTIFICATIONS_TRANSITIONS: 'GIFT_RACE:TRIGGER_NOTIFICATIONS_TRANSITIONS',
  CANCEL_NOTIFICATIONS_TRANSITIONS: 'GIFT_RACE:CANCEL_NOTIFICATIONS_TRANSITIONS',
  START: 'GIFT_RACE:START',
  FLUSH_NOTIFICATIONS: 'GIFT_RACE:FLUSH_NOTIFICATIONS',
  CLAIM_REWARD: 'GIFT_RACE:CLAIM_REWARD',
  RESTART_ROUND: 'GIFT_RACE:RESTART_ROUND',
});

export type GRStateActionType = ObjectValuesUnionType<typeof GRStateActionTypes>;
